<template>
    <div>
        <div>
            <el-form :inline="true" :model="form" style="text-align:left;">
                <el-form-item label="综合查询:">
                    <el-input v-model="form.salesInfo" placeholder="请输入销售员姓名/电话" :clearable="true"></el-input>
                </el-form-item> 
                <el-form-item label="机构:">
                    <My-Select v-model="form.agentBranchCode" :objSelect="form.agentBranchCode" :placeholder="agentQueryPlaceholder" :optionBind="optionBindBran" :options="queryAgentBranList" @changeSelct="changeQueryAgentBran"></My-Select>                 
                </el-form-item> 
                <el-form-item >
                    <el-button type="primary" plain @click="query()">查询</el-button>  
                    <el-button type="primary" plain @click="salesEditor('add')">新建</el-button>                         
                </el-form-item>           
            </el-form>
        </div>
        <div>
            <My-table :configurationData="configurationData" :operation="operation" :getTableParam="getTableParam" ref="myTable">           
                <template #operation="scope">        
                    <el-button size="mini" type="primary" @click="salesEditor('update',scope.row)">修改</el-button>
                </template>
            </My-table> 
        </div>

        <el-dialog :title="title"  :visible.sync="salesEditorDialog" :close-on-click-modal=false width="1200px">
            <el-form :model="editorForm"  :inline="true" :rules="rules" ref="editorForm" label-width="155px" style="text-align:left">
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="承销商:" prop="agentCode" class="sale-select">
                            <My-Select v-model="editorForm.agentCode" :objSelect="editorForm.agentCode" :optionBind="optionBindAgent" :options="agentList" :placeholder="agentPlaceholder"  @changeSelct="changeAgent"></My-Select>                 
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="机构名称:" prop="agentBranCode" class="sale-select">
                            <My-Select v-model="editorForm.agentBranCode" :objSelect="editorForm.agentBranCode" :optionBind="optionBindBran" :options="agentBranList" :placeholder="agentBranPlaceholder"  @changeSelct="changeAgentBran"></My-Select>                 
                        </el-form-item> 
                    </el-col>
                </el-row>
                <el-row>                   
                    <el-col :span="12">
                        <el-form-item label="销售级别:" prop="salesLevel" class="sale-select">
                            <My-Select  v-model="editorForm.salesLevel" :objSelect="editorForm.salesLevel" :options="options2" :placeholder="salesLevelPlaceholder" @changeSelct="changeSalesLevel"></My-Select>                                
                        </el-form-item>  
                    </el-col>               
                    <el-col :span="12">
                        <el-form-item label="一级销售员姓名/电话" v-show="selectOne" class="sale-select">
                            <My-Select v-model="editorForm.fistNameAndPhone" :objSelect="editorForm.fistNameAndPhone" :optionBind="optionBindFirstLevel" :options="firstLevelList" :placeholder="selectOnePlaceholder" @changeSelct="changeOneSalesLevel"></My-Select>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="二级销售员姓名/电话" v-show="levelThr" class="sale-select">
                            <My-Select  v-model="editorForm.secondNameAndPhone" :objSelect="editorForm.secondNameAndPhone" :options="secondLevelList" :optionBind="optionBindSecondLevel" :placeholder="selectTwoPlaceholder" @changeSelct="changeTwoSalesLevel"></My-Select>
                        </el-form-item>
                    </el-col>               
                    <el-col :span="12">                       
                        <el-form-item label="二级销售员姓名/电话" v-show="levelTwo"  prop="secondLevel" class="name-input">
                            <el-input v-model="editorForm.secondLevel" placeholder="请输入二级销售员姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="" v-show="levelTwo"  prop="secondPhone" class="name-input">
                            <el-input v-model="editorForm.secondPhone" placeholder="请输入二级销售员电话"></el-input>
                        </el-form-item>

                        <el-form-item label="一级销售员姓名/电话" v-show="levelOne"   prop="fistLevel" class="name-input">
                            <el-input v-model="editorForm.fistLevel" placeholder="请输入一级销售员姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="" v-show="levelOne"  prop="fistPhone" class="name-input">                          
                            <el-input v-model="editorForm.fistPhone" placeholder="请输入一级销售员电话" ></el-input>
                        </el-form-item>

                        <el-form-item label="三级销售员姓名/电话" v-show="levelThr"  prop="tertiaryLevel" class="name-input">
                            <el-input v-model="editorForm.tertiaryLevel" placeholder="请输入三级销售员姓名"></el-input>
                        </el-form-item>
                        <el-form-item label="" v-show="levelThr"  prop="tertiaryPhone" class="name-input">
                            <el-input v-model="editorForm.tertiaryPhone" placeholder="请输入三级销售员电话"></el-input>
                        </el-form-item>
                    </el-col>
                     </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="身份证号" prop="idCard" class="bank-info-input">
                            <el-input v-model="editorForm.idCard" placeholder="请输入身份证号"></el-input>
                        </el-form-item>
                    </el-col>               
                    <el-col :span="12">
                        <el-form-item label="开户行:" prop="bankName" class="bank-info-input">
                            <el-input v-model="editorForm.bankName" placeholder="请输入开户行"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row>
                    <el-col :span="12">
                        <el-form-item label="银行卡号:" prop="bankCardNum" class="bank-info-input">
                            <el-input v-model="editorForm.bankCardNum" placeholder="请输入银行卡号"></el-input>
                        </el-form-item>
                    </el-col>               
                    <el-col  :span="12">
                        <el-form-item label="状态:" prop="state">
                            <el-switch v-model="editorForm.state"></el-switch>
                        </el-form-item> 
                    </el-col>                   
                </el-row>
            </el-form>      
   
            <div slot="footer" style="text-align:center">
                <el-button type="primary" @click="submitForm('editorForm')">确定</el-button>
                <el-button @click="resetForm('editorForm')">取消</el-button>
            </div>
        </el-dialog>  
    </div>
</template>

<script>
import common from "../../../public/static/common.js";
export default { 
    name: 'salesManagement',
    data(){
        return{            
            title:'',
            optionBindAgent:{
                label:"agentName",
                value:"agentCode"
            },
            optionBindBran:{
                label:"agentBranName",
                value:"agentBranCode"
            },
            optionBindFirstLevel:{
                label:"fistNameAndPhone",
                value:"fistNameAndPhone"
            },
            optionBindSecondLevel:{
                label:"secondNameAndPhone",
                value:"secondNameAndPhone"
            },
            operationType:'',
            agentQueryPlaceholder:'请选择机构',
            agentPlaceholder:'请选择承销商名称',
            agentBranPlaceholder:'请选择机构名称',
            salesLevelPlaceholder:'请选择销售级别',
            selectTwoPlaceholder:'请选择二级销售姓名/电话',
            selectOnePlaceholder:'请选择一级销售姓名/电话',
            form:{
                salesInfo:'',
                agentBranchCode:'',
            },
             // 列表配置
            configurationData:[
                {
                    title: '机构名称',
                    propertys: 'agentBranName',
                    width: ''
                },{
                    title: '一级销售员',
                    propertys: 'fistSales',
                    width: ''
                },
                {
                    title: '二级销售员',
                    propertys: 'secondSales',
                    width: ''
                },
                {
                    title: '三级销售员',
                    propertys: 'tertiarySales',
                    width: ''
                },
                {
                    title: '销售级别',
                    propertys: 'salesLevel',
                    width: '',
                    format:this.formatLevel
                },
                {
                    title: '状态',
                    propertys: 'state',
                    width: '',
                    format:common.formatState
                }
            ],
             // 是否有操作按钮 宽度
            operation: {
                show: true,
                width: ''
            },
            getTableParam:{
                url:'/extwarapi/api/agentSalesMan/page',
                param:''
            },
            salesEditorDialog:false,
            queryAgentBranList:[],
            agentBranList:[],   
            agentList:[], 
            firstLevelList:[],  
            secondLevelList:[],      
            options2:[
                {"key":'1',"value":'一级销售员'},
                {"key":'2',"value":'二级销售员'},
                {"key":'3',"value":'三级销售员'},
            ],
            levelOne:false,
            levelTwo:false,
            levelThr:true,
            selectOne:true,
            editorForm:{
                id:'',
                agentCode:'',
                agentSalesName:'',
                agentBranCode:'',
                salesLevel:'3',
                fistLevel:'',
                fistPhone:'',
                fistSalesCode:'',
                secondSalesCode:'',
                secondLevel:'',
                secondPhone:'',
                tertiaryLevel:'',
                tertiaryPhone:'',
                idCard:'',
                bankName:'',
                bankCardNum:'',
                state:true,
                createUser:'',
                modifyUser:'',
                fistNameAndPhone:'',
                secondNameAndPhone:''
            },
            rules: {
                agentCode:[
                    { required: true, message: '请选择承销商', trigger: 'blur' }
                ],
                agentBranCode: [
                    { required: true, message: '请选择机构名称', trigger: 'blur' }
                ],
                salesLevel: [
                    { required: true, message: '请选择销售级别', trigger: 'blur' }
                ],
                fistLevel: [
                    { required: true, message: '请输入一级销售员姓名', trigger: 'blur' }
                ],
                fistPhone: [
                    { required: true, message: '请输入一级销售员电话/手机号格式不正确', pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }
                ],
                secondLevel: [
                    { required: true, message: '请输入二级销售员姓名', trigger: 'blur' }
                ],
                secondPhone: [
                    { required: true, message: '请输入二级销售员电话/手机号格式不正确', pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }
                ],
                tertiaryLevel: [
                    { required: true, message: '请输入三级销售员姓名', trigger: 'blur' }
                ],
                tertiaryPhone: [
                    { required: true, message: '请输入三级销售员电话/手机号格式不正确', pattern: /^1[3456789]\d{9}$/, trigger: 'blur' }
                ],
                idCard: [
                    { required: true, message: '请输入身份证号', trigger: 'blur' }
                ],
                bankName: [
                    { required: true, message: '请输入开户行', trigger: 'blur' }
                ],
                bankCardNum: [
                    { required: true, message: '请输入银行卡号', trigger: 'blur' }
                ],
                state: [
                    { required: true, trigger: 'blur' }
                ]
            },
            branchCounter:0,
            firstSalesCounter:0,
            //secondSalesCounter:0
            
        }
    },
    methods:{
        //列表销售级别处理
        formatLevel:function(row){
            if(row.salesLevel=='1'){
                return '一级销售'
            }else if(row.salesLevel=='2'){
                return '二级销售'
            }else if(row.salesLevel=='3'){
                return '三级销售'
            }
        },
        //列表状态处理
        formatState(row){        
            if(row.state=='Y'){
                return '使用中'
            }else if(row.state=='N'){
                return '停用中'
            }
        },
        salesEditor(operationType,row){
            this.operationType=operationType;
            this.branchCounter=0;
            this.firstSalesCounter=0
            //this.secondSalesCounter=0
            this.$nextTick(()=>{
                if(operationType=='update'){
                    this.title='销售员修改';
                    let url='/extwarapi/api/agentSalesMan/getDetailById';
                    this.axios.post(url, {id:row.id}).then((resp) => {
                            if(resp.data.code='0000'){
                                this.editorForm=resp.data.result;
                                if(this.editorForm.state=='Y'){
                                    this.editorForm.state=true;
                                }else if(this.editorForm.state=='N'){
                                    this.editorForm.state=false;
                                }
                                this.editorForm.fistNameAndPhone=resp.data.result.fistSales;
                                this.editorForm.secondNameAndPhone=resp.data.result.secondSales;
                                this.changeSalesLevel(this.editorForm.salesLevel);
                            }       
                        }).catch((resp) => {
                            //console.log('error', resp); 
                        })        
                }else{
                    //添加   
                    this.title='销售员新增';            
                    this.editorForm=common.emptyModel(this.editorForm,["state","salesLevel"]);
                }
            })
            
            this.salesEditorDialog=true;
        },
        query(){
            this.getTableParam.param=this.form;
            this.$refs.myTable.query(1);
        },
        changeQueryAgentBran(value){
            this.form.agentBranchCode=value;
        },
        changeSalesLevel(value){
            if(value=='1'){
                this.editorForm.secondLevel='';
                this.editorForm.secondPhone='';
                this.editorForm.secondNameAndPhone='';
                this.editorForm.secondSales='';
                this.editorForm.tertiaryLevel='';
                this.editorForm.tertiaryPhone='';
                this.editorForm.tertiarySales='';
                this.levelOne=true;
                this.levelTwo=false;
                this.levelThr=false;
                this.selectOne=false;
            }else if(value=='2'){
                this.editorForm.tertiaryLevel='';
                this.editorForm.tertiaryPhone='';
                this.editorForm.tertiarySales='';
                this.levelOne=false;
                this.levelTwo=true;
                this.levelThr=false;
                this.selectOne=true;
            }else if(value=='3'){
                this.levelOne=false;
                this.levelTwo=false;
                this.levelThr=true;
                this.selectOne=true;
            }
            this.editorForm.salesLevel=value;
        },
        //选择承销商
        changeAgent(value){           
            this.editorForm.agentCode=value;
            if(this.branchCounter>0){
                this.editorForm.agentBranCode='';
            }
            this.branchCounter=1;            
            this.getAgentBranList(value);
        },
        //选择机构
        changeAgentBran(value){                   
            this.editorForm.agentBranCode=value;    
            if(this.firstSalesCounter>0){     
                this.editorForm.fistNameAndPhone='';
                this.editorForm.secondNameAndPhone='';
                this.editorForm.fistLevel='';
                this.editorForm.fistPhone='';
                this.editorForm.secondLevel='';
                this.editorForm.secondPhone='';
            }
            this.firstSalesCounter=1; 
            this.getFistLevelEnum(value);            
        },
        //选择一级销售人员/电话
        changeOneSalesLevel(value){            
             this.editorForm.fistNameAndPhone = value;
            // if(this.secondSalesCounter>0){      
            //     this.editorForm.secondNameAndPhone='';
            //     this.editorForm.secondLevel='';
            //     this.editorForm.secondPhone='';
            // } 
            // this.secondSalesCounter=1;                        
            if(value){
                let values=value.split('/');
                this.editorForm.fistLevel=values[0];
                this.editorForm.fistPhone=values[1];

                this.getSecondLevelEnum(this.editorForm.agentBranCode,this.editorForm.fistLevel);
            }
        },
        //选择二级销售人员/电话
        changeTwoSalesLevel(value){
            this.editorForm.secondNameAndPhone = value;
            if(value){
                let values=value.split('/');
                this.editorForm.secondLevel=values[0];
                this.editorForm.secondPhone=values[1];
            }
        },
        //获取承销商集合
        getAgentList(){
            let url="/extwarapi/api/agent/getAgentEnum";
            this.axios.post(url, {}).then((resp) => {  
                    if(resp.data.code=='0000'){
                        this.agentList=resp.data.result;
                    }               
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
        },
        // 获取机构名称集合
        getAgentBranList(code){
            let url="/extwarapi/api/agent/getAgentBranchEnum";
            this.axios.post(url, {code:code}).then((resp) => {  
                    if(resp.data.code=='0000'){
                        this.agentBranList=resp.data.result;
                    }               
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
        },
        //获取一级销售人员名称/电话
        getFistLevelEnum(branCode){
            let url="/extwarapi/api/agentSalesMan/getFistLevelEnum";
            let param={
                    code:branCode
                };
            this.axios.post(url, param).then((resp) => {
                    if(resp.data.code=='0000'){
                        this.firstLevelList=resp.data.result;
                    }               
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
        },
        //获取二级销售人员名称/电话
        getSecondLevelEnum(branCode,fistLevel){
            let url="/extwarapi/api/agentSalesMan/getSecondLevelEnum";
            let param={
                    agentBranCode:branCode,
                    fistLevel:fistLevel
                };
            this.axios.post(url, param).then((resp) => {  
                    if(resp.data.code=='0000'){
                        this.secondLevelList=resp.data.result;
                    }               
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
        },
        // 获取搜索条件机构名称集合
        getQueryAgentBranList(){
            let url="/extwarapi/api/agent/getAgentBranchEnum";
            this.axios.post(url, {code:''}).then((resp) => {  
                    if(resp.data.code=='0000'){
                        this.queryAgentBranList=resp.data.result;
                    }               
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
        },
        buildParams(param,validFields){
            if(param.salesLevel=='1'){
                validFields.push("fistLevel");
                validFields.push("fistPhone");
                param.agentSalesName=this.editorForm.fistLevel;
                param.secondLevel='';
                param.secondPhone='';
                param.tertiaryLevel='';
                param.tertiaryLevel='';

            }else if(param.salesLevel=='2'){
                validFields.push("secondLevel");
                validFields.push("secondPhone");
                param.agentSalesName=this.editorForm.secondLevel;
                param.tertiaryLevel='';
                param.tertiaryLevel='';
            }else if(param.salesLevel=='3'){
                validFields.push("tertiaryLevel");
                validFields.push("tertiaryPhone");
                param.agentSalesName=this.editorForm.tertiaryLevel;
            }
        },
        getLevelCode(label,param){
            for (let i =0; i< param.length;i++){
                if (label === param[i].agentSalesName){
                    return param[i].agentSalesCode
                }
            }
        },
        getAgentSale(){
            this.editorForm.fistSalesCode = ''
            this.editorForm.secondSalesCode = ''
            if(this.editorForm.salesLevel=='1'){
                if (this.editorForm.fistLevel){
                    this.editorForm.fistSalesCode = this.getLevelCode(this.editorForm.fistLevel, this.firstLevelList)
                }
                
            }else if(this.editorForm.salesLevel=='2'){
                if (this.editorForm.fistLevel) {
                    this.editorForm.fistSalesCode = this.getLevelCode(this.editorForm.fistLevel, this.firstLevelList)
                }
                if (this.editorForm.secondLevel) {
                    this.editorForm.secondSalesCode = this.getLevelCode(this.editorForm.secondLevel, this.secondLevelList)
                }
                
            }else if(this.editorForm.salesLevel=='3'){
                if (this.editorForm.fistLevel) {
                    this.editorForm.fistSalesCode = this.getLevelCode(this.editorForm.fistLevel, this.firstLevelList)
                }
                if (this.editorForm.secondLevel) {
                    this.editorForm.secondSalesCode = this.getLevelCode(this.editorForm.secondLevel, this.secondLevelList)
                }
                
            }
        },
        submitForm(formName){
            let usercode=common.getCurrUser().userCode;
            let url="";
            this.getAgentSale()
            let param=Object.assign({},this.editorForm); 
                param.createUser=usercode;
                param.modifyUser=usercode;
            if(param.state){
                param.state='Y';
            }else{
                param.state='N';
            }
            if(this.operationType=='add'){
                url="/extwarapi/api/agentSalesMan/add";
            }else{
                url="/extwarapi/api/agentSalesMan/update";
            }
            param.agentSalesCode = param.agentSalesCode ; 
            
            console.log('param', param)
            let validFields=["agentBranCode","salesLevel","idCard","bankName","bankCardNum","state"];

            this.buildParams(param,validFields);

            let me = this;
            let allValid = true;
            this.$refs[formName].validateField(validFields,(valid) => {
                if(valid.length>0){
                    allValid = false;
                }                
            });
            if (allValid) {
                me.axios.post(url, param).then((resp) => {
                    if(resp.data.code=='0000'){
                        this.$alert("操作成功!", '提示信息', {
                            confirmButtonText: '确定',
                            callback: action => {
                                me.salesEditorDialog=false;
                                me.$refs["myTable"].query(1);
                            }
                        });
                    }else{
                        this.$alert(resp.data.msg, '提示信息', {
                                confirmButtonText: '确定',
                                callback: action => {
                                
                                }
                        });                        
                    }  
                
                }).catch((resp) => {
                    //console.log('error', resp); 
                })
            } else {
                return false;
            }
        },
        resetForm(formName){
           this.salesEditorDialog=false;
           this.$refs[formName].resetFields(); 
        },
       
    },
    mounted(){
        this.getAgentList();
        this.getQueryAgentBranList();
    },
   

 
}
</script>
<style lang="scss" >
.sale-select .el-input--suffix{
    width: 350px;
}
.name-input .el-input{
    width: 170px;
}
.bank-info-input .el-input{
    width: 350px;
}
</style>